import React from 'react'
import { fluidSMM } from './fluidFonts'
import { useTheme } from '@mui/material'

type QTitleProps = {
    title: string
}

export const QTitle: React.FC<QTitleProps> = ({ title }) => {
    const muiTheme = useTheme()
    return (
        <div className="text-center my-2 font-extrabold">
            {/* FIXME className="text-lg" removed(using fluidSMM) */}
            <span style={{
                ...fluidSMM,
                color: muiTheme.palette.text.primary,
            }} >
                {title}
            </span>
        </div>
    )
} 